<!--  -->
<template>
    <div>
        <Header></Header>
        <div class="edit">
            <div class="top">
                <el-breadcrumb separator="/">
                    <el-breadcrumb-item :to="{ path: '/tabel' }">督导评估</el-breadcrumb-item>
                    <el-breadcrumb-item>编辑</el-breadcrumb-item>
                </el-breadcrumb>
            </div>
            <div class="content">
                <el-form :model="dynamicValidateForm" ref="dynamicValidateForm" label-width="100px"
                    class="demo-dynamic">
                    <div class="item" v-for="(item,index) in dynamicValidateForm.domains" :key="index">
                        <el-form-item prop="counten" label="评估内容">
                            <el-input v-model="item.content"></el-input>
                            <el-form-item prop="reason2" label="评估要素" v-for="(items,indexs) in item.child"
                                :key="indexs">
                                <el-input v-model="items.reason2"></el-input>
                            </el-form-item>
                        </el-form-item>
                        <el-form-item prop="score" label="分数">
                            <div class="score">
                                <el-input v-model="item.score"></el-input>
                                <span style="margin:0 10px">分</span>
                                <i class="el-icon-circle-plus-outline add" @click="addDomain"></i>
                            </div>
                            <el-form-item prop="score3" label="分数" v-for="(items,indexs) in item.child" :key="indexs">
                                <div class="score">
                                    <el-input v-model="items.score3"></el-input>
                                    <span style="margin:0 10px">分</span>
                                    <i class="el-icon-circle-plus-outline add" @click="addDomain2(index,indexs)"></i>
                                </div>
                            </el-form-item>
                        </el-form-item>
                        <el-form-item>
                        </el-form-item>
                    </div>
                </el-form>
                <div class="btn">
                    <el-button type="primary" @click="save">保存</el-button>
                    <el-button type="info">取消</el-button>
                </div>
            </div>

        </div>
        <Footer></Footer>
    </div>
</template>
<script>
    export default {
        data() {
            return {
                dynamicValidateForm: {
                    domains: [{
                            content: '引领育人',
                            score: '16',
                            child: [{
                                    reason2: '坚持育人为本、德育为先，围绕立德树人的根本任务，用社会主义核心价值观引领学校育人目标和办学思想。校长作为第一责任人，以身作则，定期组织研究培育和践行社会主义核心价值观工作，统筹领导，明确学校各管理部门、各学科责任，管理到位',
                                    score3: '8'
                                },
                                {
                                    reason2: '学校制定的发展规划和年度工作计划体现培育和践行社会主义核心价值观内容，明确长远目标，突出阶段性任务，思路清晰，举措具体，推进有力。',
                                    score3: '8'
                                },
                            ]
                        },
                        {
                            content: '融入课堂',
                            score: '14',
                            child: [{
                                    reason2: '学校以社会主义核心价值观引领课程建设。加强《道德与法治入《思想政治》课的教学和管理。结合学校工作实际，开发校本课程，丰富教育教学资源;加强学科间相互配合，发挥综合育人作用。',
                                    score3: '8'
                                },
                                {
                                    reason2: '改进德育课程和共青团、少先队活动的内容、方式，针对性和实效性强，受学生欢迎。',
                                    score3: '8'
                                },
                            ]
                        },
                        {
                            content: '文化熏陶',
                            score: '14',
                            child: [{
                                    reason2: '学校用社会主义核心价值观引领文化建设。将社会主义核心价值观融入校园物质文化、精神文化和制度文化之中。;加强学科间相互配合，发挥综合育人作用。',
                                    score3: '8'
                                },
                                {
                                    reason2: '坚持以人为本，依法治校，完善学校制度，加强学校校风、教风、学风和班风建设，规范办学行为，营造平等和谐的文化氛围。',
                                    score3: '8'
                                },
                            ]
                        },
                        {
                            content: '实践养成',
                            score: '14',
                            child: [{
                                    reason2: '学校将社会主义核心价值观内容融入各类实践活动之中，突出主题性和实效性，强化知行合一。有效落实“一十百千”工程相关要求，各学科平均应有不低于 10%课时用于开展校内外综合实践活动。',
                                    score3: '7'
                                },
                                {
                                    reason2: '学校注重行为养成教育，细化不同学段教育要求形成养成教育的制度和机制。以“三爱”“三节”、法制教育等专题教育活动为重点，通过喜闻乐见的实践形式，引导学生形成良好行为习惯。',
                                    score3: '7'
                                },
                            ]
                        },
                        {
                            content: '为人师表',
                            score: '14',
                            child: [{
                                    reason2: '把社会主义核心价值观融入教师职前准入、职后培训和管理的全过程，作为教师聘任、考核和评价的首要内容。注重德育教师、班主任的配备、选拔和培养。',
                                    score3: '7'
                                },
                                {
                                    reason2: '学校组织培育和践行社会主义核心价值观专题培训，将社会主义核心价值观内容作为校本研修的必修内容，计划性和实效性强。',
                                    score3: '7'
                                },
                            ]
                        },
                        {
                            content: '协同育人',
                            score: '9',
                            child: [{
                                    reason2: '学校建立健全协同育人机制，建立完善与社区家庭协同育人的手段方式。',
                                    score3: '5'
                                },
                                {
                                    reason2: '学校争取社区的支持和配合，协同组织社会主义核心价值观教育实践活动。',
                                    score3: '4'
                                },
                            ]
                        },
                    ],

                }
            }
        },
        methods: {
            save() {
                this.$message({
                    message: '保存成功',
                    type: 'success'
                });
            },
            addDomain() {
                this.dynamicValidateForm.domains.push({
                    content: '',
                    score: '',
                    child: [{
                        reason2: '',
                        score3: ''
                    }],
                    key: Date.now()
                }, );
            },
            addDomain2(index, indexs) {
                console.log(index, indexs);
                this.dynamicValidateForm.domains[index].child.push({
                    reason2: '',
                })
            }
        },
        mounted() {},
    };
</script>
<style lang='less' scoped>
    @import url("./less/edit.less");
</style>